/**
 * Create User Use Case
 *
 * Creates a new user in the system.
 * This use case validates input and coordinates with the repository.
 */

import type { IUserRepository } from '@domain/repositories';
import type { User } from '@domain/entities';
import { CreateUserDTO } from '@/application/dto/UserDTO';



export class CreateUserUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(input: CreateUserDTO): Promise<User> {
    // Validate input
    if (!input.email) {
      throw new Error('Email are required');
    }

    // Create user
    const user = await this.userRepository.create({
      email: input.email,
      password: input.password
    });

    return user;
  }
}
